var map = {
	"./allies.tsx": 4782,
	"./blog.tsx": 2736,
	"./contact.tsx": 630,
	"./detailBlog.tsx": 2017,
	"./gallery.tsx": 3702,
	"./home.tsx": 6945,
	"./landing.tsx": 9662,
	"./legals.tsx": 5426,
	"./login.tsx": 1648,
	"./participanteform.tsx": 8688,
	"./ranking.tsx": 6623,
	"./register.tsx": 9523,
	"./session.tsx": 7648,
	"./solution.tsx": 9226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9608;